<template>
  <div class="pageContent">
    <!--顶部一条-->
    <mu-appbar>
      <span class="topT">用户注册</span>
      <!--返回上一层-->
      <mu-icon value="keyboard_arrow_left" color="white" style="margin-bottom: -0.05rem" slot="left" v-on:click="goback" />
      <mu-icon value="keyboard_arrow_left" color="#27ba69" slot="right" />
    </mu-appbar>

    <br />

    <div class="bigpage">

      <!--普通登录-->
      <div align="left">
        <!--<mu-divider class="dividerClass"/>-->
        <mu-text-field hintText="请输入手机号" type="text" icon="smartphone" v-model="UserPhone" style="margin-left:-4% ; width:103% " />
        <nobr>
          <mu-text-field hintText="请输入短信验证码" type="text" icon="verified_user" v-model="YZM" class="txtValidate" style="margin-left:-4% ; width:72% " />

          <span v-show="haveYZM == false">
            <input type="button" id="j-popup" value="获取" style="font-size:0.32rem ;  margin-left:2% ; background-color:#27ba69 ; height: 0.65rem  ; border:none  ;  width: 27% ;  color:white" />
          </span>
          <span v-show="haveYZM == true">
            <input type="button" v-model="WaitTime" style="font-size:0.32rem ;  margin-left:2% ; background-color:#eeeeee ;   height: 0.65rem  ; border:none  ;  width: 27% ; color:#999 ;" />
          </span>
        </nobr>

        <mu-text-field hintText="请设置您的密码" type="password" icon="lock" v-model="UserPass" style="margin-left:-4% ; width:103% " />
        <mu-text-field hintText="请输入您的真实姓名" type="text" icon="person " v-model="RealName" style="margin-left:-4% ; width:103% " />
      </div>
      <div style="margin-top: 0.2rem;">
        <input type="checkbox" checked="checked" id="IsCheck" name="IsCheck" value="true" v-model="IsCheck" style="margin:0px;">
        <label style="display:inline;font-size:0.24rem;" for="IsCheck">
          同意
          <a href="http://www.998.com/UserRegister/RegServicesNew">《格林会员服务条款》</a>
          和
          <a href="http://www.998.com/UserRegister/RegPrivacy">《格林隐私声明》</a>
        </label>
      </div>
      <mu-raised-button label="注 册" @click="Register" primary="" v-bind:style="{ width:'100%',height:'0.8rem' }" style="font-size:0.3rem ; margin-top : 0.5rem" />
      <div id="captcha"></div>
      <br />
      <br />
      <br />
      <br />
      <!--<router-link slot="left" to="/user/Login" style="font-size:0.3rem ;  color:#FF8F3B  ;">
        已有账号，直接登录
      </router-link>-->

      <router-link slot="left" to="/user/CardHolderRegister" style="font-size:0.3rem ;  color:#27ba69  ;">
        银行卡合作优惠注册
      </router-link>

      <mu-toast v-if="toast" v-bind:message="this.TellUser" @close="hideToast" id="alertline" />

    </div>
  </div>
</template>




<style lang="less" scoped="">
@import '../../../assets/theme.less'; // 顶部标签变换
.mu-tabs {
  // 背景色
  background-color: #fff;
} // 未选中时候的颜色
.mu-tab-link {
  color: #999999;
  font-weight: bold;
} //  选中
.mu-tab-active {
  color: @primaryColor;
  font-weight: bold;
} // END 顶部标签变换
.pageContent {
  max-width: 480px;
  margin-left: auto;
  margin-right: auto;
  text-align: center;

  .bigpage {
    width: 80%;
    text-align: center;
    margin-left: auto;
    margin-right: auto;
  }

  .Green {
    background-color: @primaryColor;
  }

  .Black {
    color: @primaryBlack;
  }

  .Grey {
    color: @textColor;
  }
}
</style>


<script>
import { mapMutations, mapGetters } from 'vuex'
import api from '../../../api'

export default {
  data() {
    return {
      // 验证图片
      TPFJM: '',
      haveYZM: false,
      WaitTime: '',
      Time: 29,

      //  输入框初始化 2
      UserPhone: '',
      UserPass: '',
      RealName: '',
      FJM: '',
      YZM: '',

      IsCheck:true,
      //  输入框初始化  END  2

      // 弹出层 弹出内容
      toast: false,
      TellUser: '',
      // 弹出层 弹出内容  END

      //网易云盾验证码
      validate: '',
      //屏幕宽度
      WinWidth: document.body.clientWidth,
      ip_address : returnCitySN["cip"],
    }
  },
  //进入时运作
  activated() {
    this.UserPhone = ''
    this.UserPass = ''
    this.RealName = ''
    this.FJM = ''
    this.YZM = ''
    this.InitNetEaseDun()
    //this.getValidateCode()
  },
  // 数据获取
  computed: {
    ...mapGetters(['g_UserInfo'])
  },
  methods: {
    ...mapMutations(['setG_UserInfo']),

    // 图片验证码
    getValidateCode() {
      // 用户已登录
      if (this.g_UserInfo.Card_no) {
        console.log(this.g_UserInfo)
        this.$router.push({ path: '/user/UserCenter' })
      }
      this.TPFJM = api.getValidateCode()
    },

    // 后退一页
    goback() {
      this.$router.push({ path: '/user/Login' })
      // javascript: history.go(-1);
    },
    // 后退一页  END

    // 弹出层
    showToast() {
      this.toast = true
      if (this.toastTimer) clearTimeout(this.toastTimer)
      this.toastTimer = setTimeout(() => {
        this.toast = false
      }, 1500)
    },
    hideToast() {
      this.toast = false
      if (this.toastTimer) clearTimeout(this.toastTimer)
    },
    // 弹出层  end

    //  获取短信验证马
    getYZM() {
      if (this.validate == '') {
        this.TellUser = '请滑动或点击完成验证'
        this.showToast()
      } else {
        // 开始计时
        this.haveYZM = true
        this.WaitTime = this.Time + '秒'
        this.timer()

        var params = new this.URLSearchParam()
        params.append('phoneNo', this.UserPhone)
        params.append('captcha', this.validate)

        this.$http
          .post(api.GetRegisterSMSCode(), params.toParam())
          .then(res => {
            window.captchaInsA.refresh() //清理验证码
            if (res.Result == true) {
              this.TellUser = res.Data
              this.showToast()
            } else {
              //登陆失败
              this.validate = '' //清空
              this.TellUser = res.Message
              this.showToast()
              this.Time = 5
            }
          })
          // .catch(function(error) {
          //   console.log(this);
          // })
      }
    },

    timer() {
      if (this.Time > 0) {
        this.Time--
        this.WaitTime = this.Time + '秒'

        setTimeout(this.timer, 1000)
      } else if (this.Time == 0) {
        this.haveYZM = false
        this.Time = 29
      }
    },

    //  获取短信验证马  END

    // 注册
    Register() {
      // 校验是否勾选同意会员服务条款
      if(!this.IsCheck){
        this.TellUser = '请阅读并同意《会员服务条款和隐私声明》';
        this.showToast();
        return;
      }
      var regNumber = /\d+/ //验证0-9的任意数字最少出现1次。
      var regString = /[a-zA-Z]+/ //验证大小写26个字母任意字母最少出现1次。

      //验证第一个字符串
      // if (  regNumber.test(this.UserPass) && regString.test(this.UserPass)) {
      //     console.log('str1：验证成功');
      // }else{
      //     console.log('str1：验证失败');
      // }

      if (this.UserPhone == '') {
        this.TellUser = '请输入手机号'
        this.showToast()
      } else if (this.UserPhone.length != 11) {
        this.TellUser = '手机号格式不正确'
        this.showToast()
      } else if (this.YZM == '') {
        this.TellUser = '请输入短信验证码'
        this.showToast()
      } else if (this.YZM.length != 6) {
        this.TellUser = '短信验证码格式不正确'
        this.showToast()
      } else if (this.UserPass == '') {
        this.TellUser = '请输入您的密码'
        this.showToast()
      } else if (this.UserPass.length < 6) {
        this.TellUser = '密码不能小于6位'
        this.showToast()
      } else if (this.UserPass.length > 15) {
        this.TellUser = '密码不能大于15位'
        this.showToast()
      } else if (
        regNumber.test(this.UserPass) == false ||
        regString.test(this.UserPass) == false
      ) {
        this.TellUser = '密码需要同时包含数字和字母'
        this.showToast()
      } else if (this.RealName == '') {
        this.TellUser = '请输入您的真实姓名'
        this.showToast()
      } else {
        var params = new this.URLSearchParam()
        params.append('phoneNo', this.UserPhone)
        params.append('validateCode', this.YZM)
        params.append('password', this.UserPass)
        params.append('name', this.RealName)
        params.append('black_box', _fmOpt.black_box)
        params.append('ip_address', this.ip_address)

        this.$http.post(api.Register(), params.toParam()).then(res => {
          console.log(res)
          if (res.Result) {
            this.TellUser = '注册成功'
            this.showToast()

            this.toastTimer1 = setTimeout(() => {
              this.SaveUserInfo(res.Data)
            }, 1500)
          } else {
            this.TellUser = res.Message
            this.showToast()
          }
        })
      }
    },
    // 常规登陆方式  END

    SaveUserInfo(result) {
      // 保存登录信息
      // 保存登录信息
      var UserInfo = this.g_UserInfo

      UserInfo = result

      if (result.Card_Kind_Diplay == '网上数字卡') {
        result.Card_Kind_Diplay = '数字卡'
      }

      UserInfo.OrderRefresh1 = true
      UserInfo.OrderRefresh2 = true
      UserInfo.OrderRefresh3 = true

      this.setG_UserInfo(UserInfo)

      this.UserName = ''
      this.UserPass = ''
      this.YZM = ''

      this.$router.push({ path: '/user/UserCenter' })
    },
    InitNetEaseDun() {
      if (window.captchaInsA != undefined) {
        return
      }
      //网易云盾初始化
      var that = this
      var captchaIns
      var winWidth = this.WinWidth <= 320 ? 'auto' : '280'
      initNECaptcha(
        {
          element: '#captcha',
          captchaId: '883464f032c9481a891b5fb9fb49bd23',
          mode: 'popup',
          width: winWidth,
          onVerify: function(err, data) {
            if (
              err != undefined ||
              data == undefined ||
              data.validate == undefined
            ) {
              that.validate = ''
              that.TellUser = '验证有误！请重新验证'
              that.toastTimer = 5
              that.showToast()
              return
            }
            that.validate = data.validate
            that.getYZM()
          }
        },
        function(instance) {
          // 初始化成功后得到验证实例instance，可以调用实例的方法
          captchaIns = instance
          window.captchaInsA = captchaIns
        },
        function(err) {
          // 初始化失败后触发该函数，err对象描述当前错误信息
        }
      )

      // 监听button的点击事件，弹出验证码
      document.getElementById('j-popup').addEventListener('click', function() {
        if (that.UserPhone == '') {
          that.TellUser = '请输入手机号'
          that.showToast()
        } else if (that.UserPhone.length != 11) {
          that.TellUser = '手机号格式不正确'
          that.showToast()
        } else {
          if (that.validate.length > 0) {
            //that.getYZM()
            //return
            captchaIns.refresh()
          }
          captchaIns.popUp()
        }
      })
    }
  }
}
</script>










// WEBPACK FOOTER //
// Register.vue?26dcc67e